var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-page"},[_c('img',{attrs:{"src":"//static.buwangchuxin.com/red_open_palm/image/new/404.png","alt":""}})])
}]

export { render, staticRenderFns }